// use localStorage to store the authority info, which might be sent from server in actual project.
export function getAuthority() {
  // console.log('get Authority....');
  const permissions = localStorage.getItem('permissions');
  return permissions ? permissions.split(',') : [];
}

export function setAuthority(authority) {
  return localStorage.setItem('permissions', authority);
}
